import useFetch, { UseFetchResult } from "../../../hooks/fetch/useFetch";
import { Domain } from "../models/Domain";
import { DomainEdit } from "../models/DomainEdit";

interface IUseEditDomain {
  id: string;
}

interface IUseEditDomainReturn {
  fetch: UseFetchResult<Domain, DomainEdit>;
}

export const useEditDomain = ({ id }: IUseEditDomain): IUseEditDomainReturn => {
  const fetch = useFetch<Domain, DomainEdit>(`/api/domains/${id}`, {
    skipInitialFetch: true,
    method: "put",
    withToast: true,
  });

  return {
    fetch,
  };
};
